import React from "react";
import { SecurityIssue } from "../../types/security";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { getSeverityColor, formatRiskScore, getIssueStatusColor } from "@/utils/securityHelpers";

interface SecurityIssuesListProps {
  issues: SecurityIssue[];
  onIssueClick: (issue: SecurityIssue) => void;
}

export const SecurityIssuesList: React.FC<SecurityIssuesListProps> = ({ issues, onIssueClick }) => {
  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow className="h-8">
            <TableHead className="py-2 text-xs">Title</TableHead>
            <TableHead className="py-2 text-xs">Severity</TableHead>
            <TableHead className="py-2 text-xs">Status</TableHead>
            <TableHead className="py-2 text-xs">Risk Score</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {issues.map((issue) => (
            <TableRow
              key={issue.id}
              className="cursor-pointer hover:bg-muted/50 transition-colors h-12"
              onClick={() => onIssueClick(issue)}
            >
              <TableCell className="max-w-md truncate py-2">
                <span className="text-xs">{issue.title}</span>
              </TableCell>
              <TableCell className="py-2">
                <Badge className={`${getSeverityColor(issue.severity)} text-xs px-2 py-0.5`}>
                  {issue.severity}
                </Badge>
              </TableCell>
              <TableCell className="py-2">
                <Badge
                  variant="outline"
                  className={`${getIssueStatusColor(issue.status)} text-xs px-2 py-0.5`}
                >
                  {issue.status.replace(/_/g, " ")}
                </Badge>
              </TableCell>
              <TableCell className="py-2">
                <div className="flex items-center gap-1.5">
                  <div className="w-16 h-1.5 bg-gray-200 rounded-full overflow-hidden">
                    <div
                      className={`h-full ${
                        issue.riskScore >= 0.8
                          ? "bg-red-600"
                          : issue.riskScore >= 0.6
                            ? "bg-orange-500"
                            : issue.riskScore >= 0.4
                              ? "bg-yellow-500"
                              : "bg-green-500"
                      }`}
                      style={{ width: `${issue.riskScore * 100}%` }}
                    />
                  </div>
                  <span className="text-xs font-medium">{formatRiskScore(issue.riskScore)}</span>
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
